import { render, staticRenderFns } from "./add-user-to-team-modal.vue?vue&type=template&id=3b9199fe"
import script from "./add-user-to-team-modal.vue?vue&type=script&lang=js"
export * from "./add-user-to-team-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports